export function finalizeWordPlacement(engine, game, word, row, col, direction) {
  game.settings.placedWords.push({
    word,
    row,
    col,
    direction,
    length: word.length,
  });

  engine.state.removeUnplaced(word);
  engine.state.clearFailures(word);
}
